import styled, { css } from "styled-components";

const Columns = styled.div`
  ${({ $backgroundColor }) =>
    $backgroundColor &&
    css`
      background-color: ${$backgroundColor};
    `}
  ${({ $textColor }) =>
    $textColor &&
    css`
      color: ${$textColor};
    `}
  ${({ $linkColor }) =>
    $linkColor &&
    css`
      a {
        color: ${$linkColor};
      }
    `}
  display: flex;
  flex-flow: row wrap;
  gap: ${({ $noGap }) => ($noGap === true ? 0 : "0.875rem")};
  align-items: stretch;
  width: 100%;
  padding: ${({ $padding }) => $padding};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: block;
    align-items: unset;
    flex-flow: unset;
    padding-inline: 0;
  }
`;

export default Columns;
